import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

// Packages
import { Helmet } from 'react-helmet';

// Actions
import {
  getProfileAccountDetails
} from '../../actions/accountDetails'

// Components
import Header from '../../components/Global/Header';
import DashboardHeader from '../../components/Dashboard/DashboardHeader';
import CoachSearchForm from '../../components/CoachSearch/CoachSearchForm';
import ResourceLibraryOverview from '../../components/ResourceLibrary/ResourceLibraryOverview';
import Footer from '../../components/Global/Footer';
import AppCanvasLoader from '../../components/Global/AppCanvasLoader';

class Dashboard extends Component {

  state = {
    isLoading: false
  }

  handleIncompleteUserProfileRedirect = (currentForm, prevForm) => {
    this.props.updateOnboardingForm({
      prevForm,
      currentForm
    })
    this.props.history.push(`/sign-up/${currentForm}`);
  }

  render() {
    const { path, appName, activeProfile } = this.props;
    const { isLoading } = this.state;
    const { isLoggedIn, reduxLogInComplete, role } = this.props.user;
    const isAdmin = role === 'admin' || role === 'super admin' ? true : false;

    if (isLoggedIn && !reduxLogInComplete) {
      return <Redirect to={{ pathname: '/log-out' }}/>
    } else if (!isAdmin && isLoggedIn && !(activeProfile.participations.length > 0)) {
      return <Redirect to={{ pathname: '/sign-up/sport-selection' }}/>
    } else if (isLoggedIn && reduxLogInComplete) {
      return (
        <div>
          <Helmet>
            <title>{appName} | Dashboard</title>
          </Helmet>
          <Header path={ path } />
          {
            isLoading
            ? (
              <div className="dashboard-loader-container">
                <AppCanvasLoader />
              </div>
            )
            : (
              <div className="dashboard">
                <DashboardHeader />
                <div className="dashboard-content user-portal">
                  <CoachSearchForm />
                  <ResourceLibraryOverview />
                </div>
                <Footer appName={ appName } path={ path } />
              </div>
            )
          }
        </div>
      );
    }
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activeProfile: state.activeProfile,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getProfileAccountDetails: (user, profile) => dispatch(getProfileAccountDetails(user, profile))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Dashboard)



// WEBPACK FOOTER //
// ./src/screens/UserPortal/Dashboard.js